import React, { createContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

const defaultValue = {
  title: '',
  setTitle: () => {},
  description: '',
  setDescription: () => {},
  whySolutionNeeded: '',
  setWhySolutionNeeded: () => {},
  howSolutionSustainable: '',
  setHowSolutionSustainable: () => {},
  whichRegion: '',
  setWhichRegion: () => {},
  whyPromoteYourRegion: '',
  setWhyPromoteYourRegion: () => {},
  usePrizeMoney: '',
  setUsePrizeMoney: () => {},
  media: [],
  setMedia: () => {},
  firstname: '',
  setFirstname: () => {},
  lastname: '',
  setLastname: () => {},
  aboutYourself: '',
  setAboutYourself: () => {},
  dateOfBirth: '',
  setDateOfBirth: () => {},
  email: '',
  setEmail: () => {},
  regionOrPlace: '',
  setRegionOrPlace: () => {},
  acceptTerms: false,
  setAcceptTerms: () => {}
};

export const SubmissionContext = createContext(defaultValue);

const SubmissionContextProvider = ({ children }) => {
  const [title, setTitle] = useState(defaultValue.title);
  const [description, setDescription] = useState(defaultValue.description);
  const [whySolutionNeeded, setWhySolutionNeeded] = useState(defaultValue.whySolutionNeeded);
  const [howSolutionSustainable, setHowSolutionSustainable] = useState(
    defaultValue.howSolutionSustainable
  );
  const [whichRegion, setWhichRegion] = useState(defaultValue.whichRegion);
  const [whyPromoteYourRegion, setWhyPromoteYourRegion] = useState(
    defaultValue.whyPromoteYourRegion
  );
  const [usePrizeMoney, setUsePrizeMoney] = useState(defaultValue.usePrizeMoney);
  const [media, setMedia] = useState(defaultValue.media);
  const [firstname, setFirstname] = useState(defaultValue.firstname);
  const [lastname, setLastname] = useState(defaultValue.lastname);
  const [aboutYourself, setAboutYourself] = useState(defaultValue.aboutYourself);
  const [dateOfBirth, setDateOfBirth] = useState(defaultValue.dateOfBirth);
  const [email, setEmail] = useState(defaultValue.email);
  const [regionOrPlace, setRegionOrPlace] = useState(defaultValue.regionOrPlace);
  const [acceptTerms, setAcceptTerms] = useState(defaultValue.acceptTerms);

  const submissionState = useMemo(
    () => ({
      title,
      setTitle,
      description,
      setDescription,
      whySolutionNeeded,
      setWhySolutionNeeded,
      howSolutionSustainable,
      setHowSolutionSustainable,
      whichRegion,
      setWhichRegion,
      whyPromoteYourRegion,
      setWhyPromoteYourRegion,
      usePrizeMoney,
      setUsePrizeMoney,
      media,
      setMedia,
      firstname,
      setFirstname,
      lastname,
      setLastname,
      aboutYourself,
      setAboutYourself,
      dateOfBirth,
      setDateOfBirth,
      email,
      setEmail,
      regionOrPlace,
      setRegionOrPlace,
      acceptTerms,
      setAcceptTerms
    }),
    [
      title,
      description,
      whySolutionNeeded,
      howSolutionSustainable,
      whichRegion,
      whyPromoteYourRegion,
      usePrizeMoney,
      media,
      firstname,
      lastname,
      aboutYourself,
      dateOfBirth,
      email,
      regionOrPlace,
      acceptTerms
    ]
  );

  return (
    <SubmissionContext.Provider value={submissionState}>{children}</SubmissionContext.Provider>
  );
};

SubmissionContextProvider.propTypes = {
  children: PropTypes.any
};

export default SubmissionContextProvider;
